<template>
  <div class="white upload-screen-1-container">
    <div class="important-details-container">
      <!--div-- class="back-icon text-xs-left">
        <v-icon>keyboard_backspace</v-icon>
      </div-->
      <div class="important-details">Make it popular</div>
    </div>
    <hr class="hr-text">

    <v-layout row wrap class="img-and-caption-container">
      <v-flex xs4 md1 class="img-container">
        <img src="https://res.cloudinary.com/viewzzz/image/upload/w_auto/v1523306017/dpfvh28om5ef75hlbdtc.jpg"/>
      </v-flex>
      <v-flex xs8 md11 class="caption-container">
        The more relevant tags you add to this photo, the more people will discover it.
      </v-flex>
    </v-layout>

    <v-layout row wrap justify-space-between class="tags-container">
       <v-flex class="tag-headline text-xs-left">
         Tags: Selected
       </v-flex>
      <v-flex class="tag-btn-container text-xs-right">
         <v-btn class="cyan white--text" round small style="margin: 0; font-size: 11px">Add new</v-btn>
      </v-flex>
    </v-layout>

    <div class="tags-chip-container text-xs-left" style="display: flex; flex-wrap: wrap">
      <div  style="position: relative;" v-for="(chip,chipIndex) in selectedTags" :key="chipIndex">
        <v-icon
          @click="selectedTags.splice(chipIndex, 1)"
          style="position: absolute; top: 7px; right: 13px; font-size: 18px"
        >
          clear
        </v-icon>
        <v-chip
          style="width: 95px; font-size: 12px"
          outline
          label
          class="blue black--text"
          small
        >
          {{chip}}
        </v-chip>
      </div>
    </div>


    <v-layout row wrap justify-space-between class="tags-container mt-3">
      <v-flex class="tag-headline text-xs-left">
        Suggested
      </v-flex>
    </v-layout>

    <div class="text-xs-left">
      <button
        @click="selectedTags.push(suggestionText)"
        v-for="suggestionText in suggestions"
        class="suggestion-btn"
      >
        {{suggestionText}}
      </button>
    </div>




  </div>
</template>

<script>
  export default {
    data () {
      return {
        switchToggle: true,
        suggestions: [
          'architecture',
          'mountains',
          'river',
          'summer',
          'architecture',
          'modernism',
          'trolltunga'
        ],
        selectedTags: []
      }
    }
  }
</script>

<style lang="scss" scoped>
  .upload-screen-1-container {
    height: 100vh;
    width: 100%;
    padding: 25px;
    .hr-text {
      line-height: 1em;
      position: relative;
      outline: 0;
      border: 0;
      color: black;
      text-align: center;
      height: 1.5em;
      opacity: .5;
      &:before {
        content: '';
        background: #818078;
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 1px;
      }
      &:after {
        -webkit-font-feature-settings: 'liga';
        position: relative;
        margin-left: -100%;
        margin-top: -6px;
        font-size: 24px;
        display: inline-block;
        font-family: 'Material Icons';
        content: "keyboard_backspace";
        -webkit-font-feature-settings: 'liga' 1;
        -moz-font-feature-settings: 'liga' 1;
        font-feature-settings: 'liga' 1;

        padding: 0 .5em;
        line-height: 1.5em;
        // this is really the only tricky part, you need to specify the background color of the container element...
        color: #818078;
        background-color: #fcfcfa;
      }
    }
    .suggestion-btn {
      margin: 5px 5px;
      padding: 5px 20px;
      border: 1px solid lightgrey;
      border-radius: 10px;
      outline: none;
      font-size: 0.714em;
    }
    .tags-container {
      .tag-headline {
        font-size: 1.286em;
        font-weight: 700;
      }
      .tag-btn {

      }
    }
    .important-details-container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      position: relative;

      .back-icon {
        position: absolute;
        left: 0;
        top: 58%
      }
      .important-details {
        width: 98%;
        text-align: right;
        font-size: 1.286em;
        font-weight: 700;
      }
      .hr-div {
        margin-left: 20px ;
        position: absolute;
        width: 90%;
        top: 58%;
        left: 20px;
        background: lightgrey;
        height: 1px;
      }
    }
    .img-and-caption-container {
      border-bottom: 1px solid lightgrey;
      margin: 19px 0 9px 0;
      .img-container {
        img {
          width: 6.429em;
          height: 4.286em;
          object-fit: cover;
        }
      }
      .caption-container {
        padding-left: 10px;
        text-align: left;
        .caption-text-area {
          width: 100%;
          height: 100%;
          outline: none;
          resize: none;
          ::placeholder {
            font-size: 1em;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// uploadScreen-2.vue?2af9ab19